import { useEffect } from "react";

type UseCanonicalOptions = {
  /** Se não passar, usa window.location.href sem query/hash */
  canonical?: string;
  /** Domínio base, caso você queira montar com pathname */
  origin?: string;
  /** Se true, remove query/hash do canonical final */
  stripQueryAndHash?: boolean;
};

function normalizeUrl(url: string, stripQueryAndHash: boolean) {
  try {
    const u = new URL(url);
    if (stripQueryAndHash) {
      u.search = "";
      u.hash = "";
    }
    return u.toString();
  } catch {
    // fallback se vier relativo
    return url;
  }
}

export function useCanonical(options: UseCanonicalOptions = {}) {
  useEffect(() => {
    const {
      canonical,
      origin,
      stripQueryAndHash = true,
    } = options;

    const computed =
      canonical ??
      (() => {
        const href = window.location.href;
        const normalized = normalizeUrl(href, stripQueryAndHash);
        // se origin foi passado, força usar origin + pathname
        if (origin) {
          const u = new URL(normalized);
          return new URL(u.pathname, origin).toString();
        }
        return normalized;
      })();

    let link = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');

    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }

    link.setAttribute("href", computed);
  }, [options.canonical, options.origin, options.stripQueryAndHash]);
}
